import axios from 'axios';
export const API_URL = "https://api.culsight.com/api/learner/";
export const MSCLIENT_ID = "1090756d-1917-4186-8f15-1aa3d1cddcd4";
export const TENANT_ID =  "5d7d54c4-818b-4a3d-ac8c-3ea72e6add64";
export const REDIRECTURL = "https://shalina.culsight.com/microsoft-callback";
export const MSLOGINURL = API_URL + "microsoft-login/";
export const AxiosFirst = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});
const Axios = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// ✅ REQUEST INTERCEPTOR (Header Inject Karega)
Axios.interceptors.request.use(
  (config) => {
    // Agar dynamic chahiye:
    // const clientId = localStorage.getItem("ms_client_id");

    config.headers['ms-client-id'] = MSCLIENT_ID;

    return config;
  },
  (error) => Promise.reject(error)
);

//   Add a global response interceptor
Axios.interceptors.response.use(
  (response) => {
    // Normal successful response
    return response;
  },
  async (error) => {
    // ✅ Check if token expired (401 or 403)
    if (error.response && [401, 403].includes(error.response.status)) {
      try {
        // Clear cookies
        document.cookie =
          "cf_at=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure";
        document.cookie =
          "cf_rt=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=None; Secure";
      } catch (e) { }
      // Redirect to login
      window.location.href = "/";
    }

    // ✅ Handle network or other server errors
    return Promise.reject(error);
  }
);
export default Axios;
